/*@ngInject*/
const UIManualSizeDirective = function () {

    let linkFunction = function ($scope, $elm) {

        let element = $($elm);

        function setSize(name, value) {
            if (_.isNumber(value)) {
                element.css(name, value + 'px');
            } else {
                element.css(name, value);
            }
        }

        function setupWatcher(name) {
            $scope.$watch(name, function (newValue) {
                if (newValue) {
                    setSize(name, newValue);
                }
            });
        }

        if ($scope.width) {
            setSize('width', $scope.width);
            setupWatcher('width', $scope.width);
        }

        if ($scope.height) {
            setSize('height', $scope.height);
            setupWatcher('height', $scope.height);
        }

        if ($scope.maxHeight) {
            setSize('maxHeight', $scope.maxHeight);
            setupWatcher('maxHeight', $scope.maxHeight);
        }

        if ($scope.maxHeight) {
            setSize('maxHeight', $scope.maxHeight);
            setupWatcher('maxHeight', $scope.maxHeight);
        }

        if ($scope.minHeight) {
            setSize('min-height', $scope.minHeight);
            setupWatcher('min-height', $scope.minHeight);
        }

        if ($scope.minWidth) {
            setSize('minWidth', $scope.minWidth);
            setupWatcher('minWidth', $scope.minWidth);
        }

        if ($scope.flexWidth) {
            setSize('flex', '0 0 ' + $scope.flexWidth);
            setupWatcher('flexWidth', $scope.flexWidth);
        }
    };

    return {
        restrict: 'A',
        scope: {
            width: '<',
            height: '<',
            minHeight: '<',
            maxHeight: '<',
            minWidth: '<',
            flexWidth: '<'
        },
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiManualSize', UIManualSizeDirective);
